// Formatting the timer for transcribing progress
import { UploadFormService } from '@/services/uploadForm.service'

import { ITime } from '@/features/Home/components/shotlistUpload/components/UploadFileItem'
import { IUploaderForm, TPlatformValue } from '@/types/uploadForm.interface'

export const formatTimer = (timer: ITime) =>
	`${timer.minutes.toString().padStart(2, '0')}:${timer.seconds
		.toString()
		.padStart(2, '0')}`

export interface IUpdateFormByFieldData {
	task_id: string
	platform: TPlatformValue
	field: keyof IUploaderForm
	value: IUploaderForm[keyof IUploaderForm]
	is_completed: boolean
}

export const updateFormByField = async (data: IUpdateFormByFieldData) => {
	const { task_id, platform, field, value, is_completed } = data

	const dataToUpdate = {
		is_completed,
		platforms: {
			[platform]: { [field]: value }
		}
	}

	return await UploadFormService.sendFormData(task_id, dataToUpdate)
}
